//imports
import {
    FORGOT_PASSWORD_REQUEST,
    FORGOT_PASSWORD_RESULT,
    FORGOT_PASSWORD_FORGOT_PASSWORD_RESULT,
    FORGOT_PASSWORD_FORGOT_PASSWORD_REQUEST,
    FORGOT_PASSWORD_FORGOT_PASSWORD_OPEN_MODAL,
    FORGOT_PASSWORD_CONFIRM_FORGOT_PASSWORD_RESULT,
    FORGOT_PASSWORD_CONFIRM_FORGOT_PASSWORD_REQUEST,
    FORGOT_PASSWORD_CHANGE_PASSWORD_OPEN_MODAL,
    FORGOT_PASSWORD_CHANGE_PASSWORD_REQUEST,
    FORGOT_PASSWORD_CHANGE_PASSWORD_RESULT,
    FORGOT_PASSWORD_CHECK_LOGIN_USER_BY_CODE,
} from 'Redux/actionTypes';

export const forgotPasswordRequest = (username, code, password, navigate) => ({
    type: FORGOT_PASSWORD_REQUEST,
    payload: { username, code, password, navigate },
});

export const forgotPasswordResult = (result, showConfirm, error) => ({
    type: FORGOT_PASSWORD_RESULT,
    payload: { result, showConfirm, error }
});

export const forgotPasswordForgotPasswordOpenModal = (open) => ({
    type: FORGOT_PASSWORD_FORGOT_PASSWORD_OPEN_MODAL,
    payload: open
});

export const forgotPasswordForgotPasswordRequest = (data) => ({
    type: FORGOT_PASSWORD_FORGOT_PASSWORD_REQUEST,
    payload: data
});

export const forgotPasswordForgotPasswordResult = (result) => ({
    type: FORGOT_PASSWORD_FORGOT_PASSWORD_RESULT,
    payload: result
});

export const forgotPasswordConfirmForgotPasswordRequest = (data) => ({
    type: FORGOT_PASSWORD_CONFIRM_FORGOT_PASSWORD_REQUEST,
    payload: data
});

export const forgotPasswordConfirmForgotPasswordResult = (result) => ({
    type: FORGOT_PASSWORD_CONFIRM_FORGOT_PASSWORD_RESULT,
    payload: result
});

export const checkForgotPasswordUserByCode = (code, history) => ({
    type: FORGOT_PASSWORD_CHECK_LOGIN_USER_BY_CODE,
    payload: { code, history }
});

export const forgotPasswordOpenModalChangePassword = (values) => ({
    type: FORGOT_PASSWORD_CHANGE_PASSWORD_OPEN_MODAL,
    payload: values
});

export const forceChangePasswordForgotPasswordRequest = (values, history) => ({
    type: FORGOT_PASSWORD_CHANGE_PASSWORD_REQUEST,
    payload: { values, history }
});

export const forceChangePasswordForgotPasswordResult = (result) => ({
    type: FORGOT_PASSWORD_CHANGE_PASSWORD_RESULT,
    payload: result
});




